export default __webpack_public_path__ + "media/trade_hub/video-play-eb690b4d.png";